<template>
  <div class="container editForm">
    <img class="editImg" src="../../../assets/edit.png"/>
    <h3 class="editTitle better_font">You are in edit mode.</h3>
    <div v-for="work_experience in work_experiences" v-bind:key="work_experience.id">
      <WorkExperience :work_experience_data="work_experience" />
    </div>
    <div v-if="work_experiences.length === 0">
      <img class="noSchools" src="../../../assets/emptyWorkExp.png"/>
      <p class="editTitle">No work experience is listed yet! Click the button below to start!</p>
      <button class="btn btn-primary btn-form better_font centered" @click="addWorkExperience" type="button">Add Work Experience</button>
    </div>
    <div v-else>
      <button class="btn btn-primary btn-form better_font" @click="addWorkExperience" type="button">Add Another Work Experience</button>
    </div>
    <button class="btn btn-primary btn-done better_font" @click="doneEditing">Done Editing</button>
  </div>
</template>

<script>
import axios from "axios"
import WorkExperience from "./WorkExperience.vue"
export default {
  name: "work_experiences",
  components:{
    WorkExperience
  },
  data(){
    return{
      work_experiences: [],
      errors: []
    }
  },
  mounted(){
    this.getWorkExperiences()
  },
  methods:{
    getWorkExperiences(){
      axios.get(`${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/work_experiences/`)
      .then( res => {
        this.work_experiences = res.data.work_experiences
      })
      .catch( err => {
        this.errors.push(err)
      })
    },
    addWorkExperience(){
      let new_work_experience = { }
      this.work_experiences.push(new_work_experience)
    },
    doneEditing(){
      this.$emit('finishEdit');
    }
  }
}
</script>

<style scoped>

.centered {
  display: block;
  margin: 0 auto;
}


.noSchools {
  margin-right: 30%;
  margin-left: 30%;
  width: 40%;
}

.btn-form {
  background-color: #27AAE1;
  color: white;
}

.btn-form:hover {
  background-color: #1B86B5;
}

.editForm {
  background-color: #ededed;
  padding-right: 10%;
  padding-left: 10%;
  padding-top: 5%;
  padding-bottom: 5%;
  width: 100%;
}

.editImg {
  margin-left: 45%;
  margin-right: 45%;
  width: 10%;
}

.editTitle {
  color: #a6a6a6;
  text-align: center;
}

.btn-done {
  width: 50%;
  margin-left: 25%;
  margin-right: 25%;
  background-color: #a6a6a6;
  margin-top: 20px;
}

.btn-done:hover {
  background-color: #666;
}

</style>
